import React from 'react'
import { valueToRiskBracket } from '../../utils/riskConversions'
import riskImg from '../../assets/images/risk-image.png'

export const RiskExplanation = (props) =>
  <div className='risk-profile__explanation'>
    <div className='explanation'>
      <ExplanationHeading {...props} />
      <ExplanationContent {...props} />
    </div>
  </div>

const ExplanationHeading = ({ riskProfile, wealthManager }) =>
  <div className='explanation__heading'>
    <h1>
        Your Risk Profile
      { wealthManager && shouldShowCompletedByWealthManagerFor(riskProfile) &&
        <span>Completed by {wealthManager.first_name} {wealthManager.last_name}.</span>
      }
    </h1>
  </div>

const ExplanationContent = ({ riskProfile, isRetired, clientPronoun, externalRiskProfile }) => {
  const detailedRiskText = isRetired
    ? `Capacity for risk + Risk tolerance = ${clientPronoun} risk profile`
    : `Required risk + Capacity for risk + Risk tolerance = ${clientPronoun} risk profile`
  const simpleRiskText = `You have chosen to use a simple risk profile instead of the risk profile assigned to you by Wealthbit.`
  const explanationText = riskProfile.selected === 'simple' ? simpleRiskText : detailedRiskText
  const externalRiskProfileText = `Your risk profile is determined by an external risk profiling tool`
  return (
    <div className='explanation__content'>
      <div className='explanation__image'>
        <img src={riskImg} alt='Risk Image' />
      </div>
      <div className='explanation__description'>
        <div className='description'>
          <div className='description__rating'>
            <p>{valueToRiskBracket(riskProfile.rating)}</p>
          </div>
          <div className='description__explanation'>
            {externalRiskProfile ? externalRiskProfileText : explanationText}
          </div>
        </div>
      </div>
    </div>
  )
}

const shouldShowCompletedByWealthManagerFor = ({ completed_by_wealth_manager, consent_given }) =>
  !consent_given && completed_by_wealth_manager
